import { useEffect, useState } from "react"
import { Button, FileUpload, SpaceBetween } from "@cloudscape-design/components"
import { DocumentRecord } from "../models/Document"
import { useQueryData } from "../hooks/useQueryData"
import Construction from "../widgets/Construction"
import SegmentedInput from "../widgets/SegmentedInput"

export const SendFATaskSettings = {size: "medium", title: "Send Fee Agreement Task"}

export default function SendFATask({values, setMessage, execRef}: {values: any, setMessage: (s: string, t: string) => void, execRef: React.MutableRefObject<() => Promise<string>>}) {
    setMessage("Create Fee Agreement and send to client email.", "info")
    const [ document, setDocument ] = useState<DocumentRecord | null>(null)
    const [ source, setSource ] = useState<string>('')
    const [ file, setFile ] = useState<File[]>([])

    async function execute(): Promise<string> {

        values.Activity = 'Fee Agreement Sent'
        values.Template = 'Fee Agreement'
        // Get docType & base64 content
        const docType = 'application/docx' // Assuming DOCX for Fee Agreement
        const b64 = 'fake data for base64' // Placeholder, replace with actual base64 content
        values.Document = { contentType: docType, fileName: document?.Filename, base64: b64 }
        values.General.Filename = document?.Filename
        values.General.DocId = document?._id

        return 'TASK:EmailTask' // Continue on to the Email Task
    }
    execRef.current = execute

    // Find Fee Agreement Document
    const {data, isLoading, error} = useQueryData('Document', { Where: [
        {field: 'CaseId', kind: 'equals', value: values.Case._id}, 
        {field: 'DocumentType', kind: 'equals', value: 'Fee Agreement'}] })

    useEffect(() => {
        const results = data?.results
        if (isLoading) { setMessage("Loading...", "info"); return }
        if (error) { setMessage(error?.message, "error"); return }
        if (!results) { setMessage("Error loading", "error"); return }
        if (results.length === 0) {
            setMessage("No Fee Agreement found for this case", "warning")
            setSource("From Template")
        }
        if (results.length > 0) { 
            setMessage("Fee Agreement found. Ready to email", "success")
            setDocument(results[0])
            setSource("Existing Document")
        }
        if (results.length > 1) { setMessage("Multiple Fee Agreements found for this case", "warning") }
    }, [data, isLoading, error])

    function newFile(newFile: any) {
        if (newFile[0]?.name) {
        setFile(newFile)
        //   handleChange({Name: newFile[0].name})
        } 
    }

    function validate(value: string, label: string): boolean {
        const thisValid: boolean = value?.length > 0
        return thisValid
    }


    const url = `/case/${values?.Case?._id}/documents/`
    return (
        <SpaceBetween direction="vertical" size="m">
            {/* <SegmentedInput validate={validate} readOnly={false}
                label="Document Source"
                onChange= {(v) => setSource(v)}
                value={source}
                options="Existing Document;From Template;Upload File"
            /> */}
            {/* {source === "Upload File" && <FileUpload
                onChange={({ detail }) => newFile(detail.value)}
                value={file}
                i18nStrings={{
                  uploadButtonText: (e: any) =>
                    e ? "Choose files" : "Choose file",
                  dropzoneText: (e: any) =>
                    e ? "Drop files to upload"
                      : "Drop file to upload",
                  removeFileAriaLabel: (e: any) =>
                    `Remove file ${e + 1}`,
                  errorIconAriaLabel: "Error"
                } as any}
                showFileLastModified showFileSize showFileThumbnail
                constraintText="Choose or drop file here"
              />} */}
              {/* {source === "From Template" && <Button>Create Fee Agreement from Template</Button>} */}
            <div>
            <b>Client: {values.Contact?.FirstName + " " + values.Contact?.LastName}</b><br/>
            {document?.Filename ? <b>File: {document?.Filename}</b> : 
            <Button href={url}>Create Fee Agreement in Documents</Button>}
            </div>
        </SpaceBetween>
    )
}
